import styled from 'styled-components'
import { css } from '../util'
import { cssTypes } from '../types'

/**
 * @namespace TableHead
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const TableHead = styled.thead`
  ${css};
`

/**
 * @name defaultProps
 * @memberof TableHead
 * @desc Primitive's default properties
 */
TableHead.defaultProps = {}

/**
 * @name propTypes
 * @memberof TableHead
 * @desc Primitive's prop type definitions
 */
TableHead.propTypes = {
  ...cssTypes,
}

/** @component */
export default TableHead
